import { render } from "./leftBar1.vue?vue&type=template&id=85c682ac"
import script from "./leftBar1.vue?vue&type=script&lang=js"
export * from "./leftBar1.vue?vue&type=script&lang=js"

import "./leftBar1.vue?vue&type=style&index=0&id=85c682ac&lang=less"
script.render = render

export default script